import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { useSelector } from "react-redux";
import { SelectorCharacterUI } from "../introduction/SelectorCharacterUI";
import { useNavigate } from "react-router-dom";
import { DialogBarNew } from "../../components/common/DialogBarNew";
import { ButtonPlay } from "../../components/common/ButtonPlay";
import { ButtonHome } from "../../components/common/ButtonHome";
import { audiosAssets } from "../../assets/audio";
import { voicesTypeControl } from "../../types/audioType";

const steps = {
	selectCharacter: 1,
	dialogOne: 2,
	dialogTwo: 3,
	dialogThree: 4,
};
export const IntroductionTema5 = () => {
	const { loaded } = useSelector((state) => state.menu);
	const navigation = useNavigate();
	const [uiToShow, setUiToShow] = useState(steps.selectCharacter);
	useEffect(() => {
		if (loaded) {
			console.log("introduction tema 5");
			ObserverEmitter.emit(EVENTS.init_introduction);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
			</>
			{uiToShow === steps.selectCharacter && (
				<SelectorCharacterUI
					callback={() => {
						setUiToShow(steps.dialogOne);
						ObserverEmitter.emit(EVENTS.final_instructions);
						ObserverEmitter.emit(EVENTS.move_escritorio_introduction);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.introduccion.int01)
					}}
				></SelectorCharacterUI>
			)}
			{uiToShow === steps.dialogOne && (
				<DialogBarNew
					dialog={
						'¡Muy bien! veamos ahora nuestro Tema número 5: "Servicios Financieros".'
					}
					callback={() => {
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.introduccion.int02)
						setUiToShow(steps.dialogTwo);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					dialog={
						"El objetivo de nuestro tema es: Conocer las actividades que realiza un Colaborador en Tienda con la finalidad de aplicarlas en su día a día."
					}
					callback={() => {
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.introduccion.int03)
						setUiToShow(steps.dialogThree);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogThree && (
				<DialogBarNew
					dialog={
						"Al realizar las actividades y misiones que se presentan durante el recorrido obtendrás puntos que miden tu aprendizaje. La puntuación mínima para pasar la actividad es de 80."
					}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						navigation("/home5/tema5/subtema1/activityOne");
					}}
				></DialogBarNew>
			)}
		</>
	);
};